import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../i18n/index.js'

export const ChatMessagesEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full grow text-content-muted">
      <div className="flex flex-col gap-2 items-center justify-center w-full sm:w-1/2">
        <SvgIcon
          name="message-text-circle"
          size="4x"
          className="text-content-muted"
        />
        <Text className="flex text-2xl font-semibold text-content-muted">
          <T
            id="Messaging.NoMessagesYet.Title"
            defaultMessage="No messages yet."
          />
        </Text>
        <Text className="text-sm text-center text-content-muted font-light">
          <T
            id="Messaging.NoMessagesYet.Description"
            defaultMessage="Start a conversation to get going!"
          />
        </Text>
      </div>
    </div>
  )
}
